import React from 'react';
import { Routes, Route, Navigate, NavLink, useLocation } from 'react-router-dom';
import { Shield, Users, LayoutGrid } from 'lucide-react';
import PeopleAdmin from './PeopleAdmin';
import CompetenceMatrix from './CompetenceMatrix';
import './DASAdmin.css';

/**
 * DAS Admin — top-level routes:
 *   /das-admin              → redirects to /das-admin/people
 *   /das-admin/people       → enrolment list (HDO can edit)
 *   /das-admin/competence   → L/A/V/E mark matrix (HDO can edit)
 */
function DASAdmin({ user }) {
  return (
    <div className="dasa">
      <header className="dasa-header">
        <div className="dasa-eyebrow">
          <Shield size={12} /> Design Assurance · Administration
        </div>
        <h1>DAS Admin</h1>
        <p className="dasa-summary">
          People enrolled in the procedure and their Competence Matrix marks.
        </p>
      </header>

      <nav className="dasa-tabs" aria-label="DAS Admin sections">
        <NavLink
          to="/das-admin/people"
          className={({ isActive }) => `dasa-tab ${isActive ? 'is-active' : ''}`}
        >
          <Users size={14} /> People
        </NavLink>
        <NavLink
          to="/das-admin/competence"
          className={({ isActive }) => `dasa-tab ${isActive ? 'is-active' : ''}`}
        >
          <LayoutGrid size={14} /> Competence Matrix
        </NavLink>
      </nav>

      <div className="dasa-body">
        <Routes>
          <Route index element={<Navigate to="people" replace />} />
          <Route path="people"     element={<PeopleAdmin user={user} />} />
          <Route path="competence" element={<CompetenceMatrix user={user} />} />
        </Routes>
      </div>
    </div>
  );
}

export default DASAdmin;
